var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-footer white",attrs:{"id":"content-footer"}},[_c('div',{staticClass:"d-flex p-3"},[_c('span',{staticClass:"text-sm text-muted flex"},[_vm._v("© Copyright. Flatfull")]),_c('div',{staticClass:"text-sm text-muted"},[_vm._v("Version 1.2.0")])])])
}]

export { render, staticRenderFns }